/* eslint-disable unicorn/number-literal-case */
/* eslint-disable lingui/text-restrictions */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/non-nullable-type-assertion-style */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable lingui/no-unlocalized-strings */
/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable no-control-regex */
/* eslint-disable unicorn/prefer-code-point */
import { zodResolver } from "@hookform/resolvers/zod";
import {
  DownloadSimple,
  File as FileIcon,
  FileDoc,
  FileImage,
  FilePdf,
  FileText,
  Spinner,
  UploadSimple,
} from "@phosphor-icons/react";
import { JsonResume, JsonResumeParser, ReactiveResumeParser } from "@reactive-resume/parser";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
  Input,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@reactive-resume/ui";
import React from "react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { checkResumePermission } from "@/client/hooks/checkResumePermission";
import { useToast } from "@/client/hooks/use-toast";
import { SYSTEM_PROMPTS } from "@/client/services/llm/agent-prompt";
import { deleteFile, getFileContent, uploadFile } from "@/client/services/llm/ai";
import { generateResumeTitle } from "@/client/services/llm/generateResumeTitle";
import { useImportResume } from "@/client/services/resume/import";
import { useUser } from "@/client/services/user";
import { useDialog } from "@/client/stores/dialog";
import { ChatCompletionOptions } from "@/server/agent/zhipu/zhipu.types";

/**
 * 清理JSON字符串中的控制字符和其他可能导致解析错误的问题
 * @param jsonString 原始JSON字符串
 * @returns 清理后的JSON字符串
 */
const sanitizeJsonString = (jsonString: string): string => {
  // 1. 移除所有控制字符（ASCII码小于32的字符，除了空格、换行、回车和制表符）
  let cleaned = jsonString.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, "");

  // 2. 处理HTML中可能出现的未转义双引号问题
  // 查找HTML标签中的属性，确保属性值中的双引号被正确转义
  cleaned = cleaned.replace(/(<[^>]*)(")(.*?)(")([^>]*>)/g, (match, p1, p2, p3, p4, p5) => {
    // 如果这是一个HTML标签内的属性值，确保内部的双引号被转义
    return `${p1}${p2}${p3.replace(/"/g, String.raw`\"`)}${p4}${p5}`;
  });

  // 3. 确保JSON中的转义字符是正确的
  // 修复可能错误的转义序列
  cleaned = cleaned.replace(/\\([^"/\\bfnrtu])/g, String.raw`\\$1`);

  // 4. 处理可能的UTF-8 BOM
  if (cleaned.charCodeAt(0) === 0xfe_ff) {
    cleaned = cleaned.slice(1);
  }

  // 5. 尝试修复常见的JSON格式错误
  // 移除尾部可能的逗号
  cleaned = cleaned.replace(/,\s*([\]}])/g, "$1");

  return cleaned;
};

/**
 * 安全地解析JSON字符串，包含错误处理和多次尝试
 * @param jsonString 要解析的JSON字符串
 * @returns 解析后的JSON对象
 */
const safeJsonParse = (jsonString: string): any => {
  try {
    // 首先尝试直接解析
    return JSON.parse(jsonString);
  } catch (error) {
    console.warn("初次JSON解析失败，尝试清理后再解析", error);

    try {
      // 清理后再次尝试解析
      const sanitized = sanitizeJsonString(jsonString);
      return JSON.parse(sanitized);
    } catch (secondError) {
      console.error("JSON清理后仍然解析失败", secondError);

      // 最后的尝试：使用更激进的清理方法
      try {
        // 移除所有非ASCII字符和所有控制字符
        const aggressivelyCleaned = jsonString
          .replace(/[^\t\n\r\u0020-\u007E]/g, "") // 只保留基本ASCII可打印字符和换行符等
          .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, ""); // 移除所有控制字符

        return JSON.parse(aggressivelyCleaned);
      } catch {
        // 所有尝试都失败，抛出原始错误
        throw new Error(`JSON解析失败: ${(error as Error).message}`);
      }
    }
  }
};

enum ImportType {
  "json-resume-json" = "json-resume-json",
}

const formSchema = z.object({
  content: z.union([z.string(), z.instanceof(File)]),
  inputMethod: z.enum(["file", "paste"]).default("file"),
  type: z.nativeEnum(ImportType).default(ImportType["json-resume-json"]),
});

type FormValues = z.infer<typeof formSchema>;

type ValidationResult =
  | {
      isValid: false;
      errors: string;
    }
  | {
      isValid: true;
      type: ImportType;
      result: JsonResume;
      isStandardJson: boolean;
    };

// 添加 dragEvent 处理函数
const FileUploadArea = ({ field }: { field: any }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  // 添加文件大小格式化函数
  const formatFileSize = (bytes: number) => {
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
    return (bytes / (1024 * 1024)).toFixed(2) + " MB";
  };

  // 获取文件图标
  const getFileIcon = (type: string) => {
    if (type.includes("pdf")) return <FilePdf />;
    if (type.includes("doc")) return <FileDoc />;
    if (type.includes("image")) return <FileImage />;
    if (type.includes("json")) return <FileIcon />;
    return <FileText />;
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const file = e.dataTransfer.files[0];
    if (file) {
      field.onChange(file);
      setSelectedFile(file);
    }
  };

  const handleClick = () => {
    const fileInput = document.querySelector<HTMLInputElement>("#file-upload");
    fileInput?.click();
  };

  return (
    <div className="relative">
      <div
        className={`border-input group relative flex min-h-[180px] cursor-pointer flex-col items-center justify-center 
          gap-4 rounded-xl border-2 border-dashed p-6 transition-all duration-200
          ${selectedFile ? "bg-accent/5" : "hover:bg-accent/5"}`}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={handleClick}
      >
        <Input
          id="file-upload"
          type="file"
          accept=".pdf,.doc,.docx,.txt,.md,.rtf,.jpg,.jpeg,.png,.gif,.webp,.svg,.json"
          className="hidden"
          onChange={(event) => {
            const file = event.target.files?.[0];
            if (file) {
              field.onChange(file);
              setSelectedFile(file);
            }
          }}
        />

        {selectedFile ? (
          <div className="flex w-full flex-col items-center">
            <div
              className="group/file flex w-full flex-col items-center gap-2 rounded-lg bg-background/80 p-4"
              title={`${selectedFile.name} (${formatFileSize(selectedFile.size)})`}
            >
              <div className="text-foreground">
                {React.cloneElement(getFileIcon(selectedFile.type) as React.ReactElement, {
                  className: "size-14",
                  weight: "thin",
                })}
              </div>

              <div className="flex flex-col items-center">
                <span className="max-w-[300px] truncate font-medium">{selectedFile.name}</span>
                <span className="text-muted-foreground text-sm">
                  {formatFileSize(selectedFile.size)}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="flex flex-col items-center gap-2 text-center">
              <UploadSimple className="text-muted-foreground size-8" />
              <div className="text-muted-foreground">
                <p className="font-medium">点击或拖拽文件到此处上传</p>
                <p className="text-sm">单个文件最大支持 10MB</p>
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-4">
              <div className="text-muted-foreground flex items-center gap-1 text-sm">
                <FilePdf className="size-4" /> PDF
              </div>
              <div className="text-muted-foreground flex items-center gap-1 text-sm">
                <FileDoc className="size-4" /> Word
              </div>
              <div className="text-muted-foreground flex items-center gap-1 text-sm">
                <FileText className="size-4" /> Text
              </div>
              <div className="text-muted-foreground flex items-center gap-1 text-sm">
                <FileImage className="size-4" /> Image
              </div>
              <div className="text-muted-foreground flex items-center gap-1 text-sm">
                <FileIcon className="size-4" /> JSON
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export const ImportDialog = () => {
  const { user } = useUser();
  const [isProcessing, setIsProcessing] = useState(false);
  const [validationResult, setValidationResult] = useState<ValidationResult | null>(null);
  const { toast } = useToast();
  const { isOpen, close } = useDialog("import");
  const { importResume, loading } = useImportResume();

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      inputMethod: "file",
    },
  });

  useEffect(() => {
    if (isOpen) onReset();
  }, [isOpen]);

  // 添加解析状态文案数组
  const parsingStates = [
    "🚀 初始化量子解析引擎...",
    "🔍 扫描文档数据结构...",
    "⚡ 提取关键信息矩阵...",
    "🧠 AI 深度解析中...",
    "🔄 智能格式重构...",
    "✨ 生成专业简历模型...",
  ];

  // 添加当前状态索引
  const [currentStateIndex, setCurrentStateIndex] = useState(0);

  // 添加生成标题的加载状态
  const [isGeneratingTitle, setIsGeneratingTitle] = useState(false);

  // 在组件顶部添加 state
  const [title, setTitle] = useState<string>("");

  // 定时切换解析状态提示
  useEffect(() => {
    if (!isProcessing) return;

    const interval = setInterval(() => {
      setCurrentStateIndex((prevIndex) => (prevIndex + 1) % parsingStates.length);
    }, 3000);

    return () => {
      clearInterval(interval);
    };
  }, [isProcessing, parsingStates.length]);

  // 处理文本内容解析
  const processTextContent = async (content: string) => {
    try {
      // 使用与 build-resume 相同的方法解析文本
      const options: ChatCompletionOptions = {
        model: "google/gemini-2.0-flash-001",
        messages: [
          { role: "system", content: SYSTEM_PROMPTS.RESUME_BUILDER },
          {
            role: "user",
            content:
              content +
              "\n请直接输出 JSON 格式数据，不要有任何多余的对话或说明。不要有 highlight 字段，去除无效信息",
          },
        ],
        temperature: 0.3,
        top_p: 0.7,
        max_tokens: 8192,
        stream: false,
      };

      const response = await fetch("/api/agent/zhipu/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(options),
      });

      if (!response.ok) {
        throw new Error(`请求失败: ${response.status}`);
      }

      const data = await response.json();
      const rawJsonText = data.choices[0].message.content
        .replace(/^```json\n/, "")
        .replace(/\n```$/, "");

      console.log("原始JSON文本长度:", rawJsonText.length);

      // 使用安全的JSON解析函数替代直接的JSON.parse
      const jsonData = safeJsonParse(rawJsonText);
      console.log("JSON解析成功");

      const parser = new JsonResumeParser();
      const validatedData = parser.validate(jsonData);

      setValidationResult({
        isValid: true,
        type: ImportType["json-resume-json"],
        result: validatedData,
        isStandardJson: false,
      });

      // 生成标题
      setIsGeneratingTitle(true);
      const generatedTitle = await generateResumeTitle(validatedData);
      setTitle(generatedTitle);
      setIsGeneratingTitle(false);

      toast({
        variant: "success",
        title: "解析成功",
        description: "简历数据已成功解析，请点击导入按钮继续",
      });
    } catch (error) {
      console.error("文本解析错误:", error);
      setValidationResult({
        isValid: false,
        errors: error instanceof Error ? error.message : "解析失败",
      });

      toast({
        variant: "error",
        title: "解析失败",
        description: error instanceof Error ? error.message : "无法解析简历数据",
      });
    }
  };

  // 处理文件解析
  const processFileContent = async (file: File) => {
    try {
      // 对于JSON文件，尝试直接解析
      if (file.type === "application/json") {
        try {
          // 读取原始JSON文件内容
          const fileContent = await file.text();

          // 使用安全的JSON解析函数替代直接的JSON.parse
          console.log("尝试解析JSON文件...");
          const jsonData = safeJsonParse(fileContent);
          console.log("JSON文件解析成功");

          // 仅做格式验证，不修改原始数据
          const parser = new ReactiveResumeParser();
          parser.validate(jsonData);

          // 保存原始JSON数据
          setValidationResult({
            isValid: true,
            type: ImportType["json-resume-json"],
            result: jsonData,
            isStandardJson: true,
          });

          // 生成标题
          setIsGeneratingTitle(true);
          const generatedTitle = await generateResumeTitle(jsonData);
          setTitle(generatedTitle);
          setIsGeneratingTitle(false);

          toast({
            variant: "success",
            title: "解析成功",
            description: "JSON 格式验证通过，请点击导入按钮继续",
          });
          return;
        } catch (jsonError) {
          console.log("JSON 格式验证失败，尝试使用 AI 解析", jsonError);
          // 如果不是标准JSON，继续使用AI解析
        }
      }

      // 上传文件到智谱AI
      const { fileId } = await uploadFile(file);

      // 获取文件内容
      const { content } = await getFileContent(fileId);

      // 使用与文本相同的方法解析内容
      await processTextContent(content);

      // 删除已处理的文件
      try {
        await deleteFile(fileId);
      } catch (deleteError) {
        console.warn("删除文件失败:", deleteError);
        // 不影响主流程
      }
    } catch (error) {
      console.error("文件处理错误:", error);
      setValidationResult({
        isValid: false,
        errors: error instanceof Error ? error.message : "处理文件失败",
      });

      toast({
        variant: "error",
        title: "处理失败",
        description: error instanceof Error ? error.message : "无法处理文件",
      });
    }
  };

  const handleContentProcess = async (values: FormValues) => {
    // 导入前检查权限
    const canCreate = await checkResumePermission();
    if (!canCreate) {
      // 保留toast提示，但不再手动打开会员页面（checkResumePermission已处理）
      toast({
        variant: "error",
        title: "会员权限",
        description: "您的简历数量已达到上限，请升级会员以导入更多简历",
      });
      return;
    }

    setIsProcessing(true);

    try {
      const { inputMethod, content } = values;

      if (inputMethod === "file" && content instanceof File) {
        await processFileContent(content);
      } else if (typeof content === "string") {
        await processTextContent(content);
      }
    } catch (error) {
      console.error("处理错误:", error);
      setValidationResult({
        isValid: false,
        errors: error instanceof Error ? error.message : "解析失败",
      });

      toast({
        variant: "error",
        title: "解析失败",
        description: error instanceof Error ? error.message : "无法解析简历数据",
      });
    } finally {
      setIsProcessing(false);
      setCurrentStateIndex(0);
    }
  };

  const onImport = async () => {
    // 导入简历时检查权限
    const canCreate = await checkResumePermission();
    if (!canCreate) {
      // 保留toast提示，但不再手动打开会员页面（checkResumePermission已处理）
      toast({
        variant: "error",
        title: "会员权限",
        description: "您的简历数量已达到上限，请升级会员以导入更多简历",
      });
      return;
    }

    if (!validationResult?.isValid) return;

    try {
      let data;

      // 对于用户上传的标准JSON文件，直接使用原始数据
      if (validationResult.isStandardJson && form.getValues().inputMethod === "file") {
        data = validationResult.result;
      } else {
        // 对于大模型生成的结果，使用与build-resume相同的处理流程
        try {
          const parser = new JsonResumeParser();
          const validatedData = parser.validate(validationResult.result);
          data = parser.convert(validatedData);
        } catch (parseError) {
          console.error("转换简历数据时出错:", parseError);
          toast({
            variant: "error",
            title: "数据转换失败",
            description: parseError instanceof Error ? parseError.message : "无法转换简历数据",
          });
          return;
        }
      }

      await importResume({
        data,
        title, // 使用 state 中保存的标题
      });

      close();
    } catch (error: unknown) {
      toast({
        variant: "error",
        title: "服务器返回错误",
        description: error instanceof Error ? error.message : undefined,
      });
    }
  };

  const onReset = () => {
    form.reset();
    setValidationResult(null);
  };

  // 修改检查逻辑
  const canStartParsing = () => {
    const values = form.getValues();
    if (values.inputMethod === "file") {
      return values.content instanceof File;
    }
    // 检查是否为字符串且非空
    return typeof values.content === "string" && values.content.trim().length > 0;
  };

  // 添加 Tab 切换处理
  const handleTabChange = (value: string) => {
    // 切换时清空 content
    form.setValue("content", "");
    form.setValue("inputMethod", value as "file" | "paste");
  };

  // 添加辅助函数
  const openInNewTab = (url: string) => {
    const win = window.open(url, "_blank");
    if (win) win.focus();
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent className="max-w-2xl">
        <Form {...form}>
          <form className="space-y-6" onSubmit={form.handleSubmit(handleContentProcess)}>
            <DialogHeader>
              <DialogTitle>
                <div className="flex items-center space-x-2.5">
                  <DownloadSimple />
                  <h2>导入简历</h2>
                </div>
              </DialogTitle>
              <DialogDescription>上传或粘贴简历内容，系统将自动解析并导入</DialogDescription>
            </DialogHeader>

            <FormField
              name="inputMethod"
              control={form.control}
              render={({ field }) => (
                <FormItem>
                  <Tabs
                    value={field.value}
                    className="w-full"
                    onValueChange={handleTabChange} // 使用新的处理函数
                  >
                    <TabsList className="grid w-full grid-cols-2">
                      <TabsTrigger value="file" className="flex items-center gap-2">
                        <UploadSimple className="size-4" />
                        文件上传
                      </TabsTrigger>
                      <TabsTrigger value="paste" className="flex items-center gap-2">
                        <FileText className="size-4" />
                        文本粘贴
                      </TabsTrigger>
                    </TabsList>

                    <TabsContent value="file" className="mt-4">
                      <FormField
                        name="content"
                        control={form.control}
                        render={({ field }) => (
                          <FormItem>
                            <FormControl>
                              <FileUploadArea field={field} />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    </TabsContent>

                    <TabsContent value="paste" className="mt-4">
                      <FormField
                        name="content"
                        control={form.control}
                        render={({ field }) => (
                          <FormItem>
                            <FormControl>
                              <textarea
                                className="min-h-[175px] w-full rounded-lg border border-gray-200 bg-background p-4 text-foreground placeholder:text-sm placeholder:text-neutral-400 focus:outline-none focus:ring-0 dark:border-neutral-900 dark:bg-background dark:text-foreground"
                                placeholder="请将简历文本粘贴到此处，支持多种简历格式。系统将自动识别并提取关键信息，包括个人信息、工作经历、教育背景等..."
                                {...{
                                  ...field,
                                  value: typeof field.value === "string" ? field.value : "",
                                }}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    </TabsContent>
                  </Tabs>
                </FormItem>
              )}
            />

            {validationResult && !validationResult.isValid && (
              <div className="border-destructive bg-destructive/10 text-destructive flex items-center gap-2 rounded-lg border p-4">
                <FileIcon className="size-4" />
                <p>解析失败：{validationResult.errors}</p>
              </div>
            )}

            <DialogFooter className="flex flex-col gap-2 sm:flex-row">
              {validationResult?.isValid ? (
                <Button
                  type="button"
                  disabled={loading || isGeneratingTitle}
                  className="flex-1"
                  onClick={onImport}
                >
                  {isGeneratingTitle ? (
                    <>
                      <Spinner className="mr-2 size-4 animate-spin" />
                      正在生成简历名称...
                    </>
                  ) : (
                    "解析完成，导入简历"
                  )}
                </Button>
              ) : (
                <Button
                  type="submit"
                  disabled={isProcessing || !canStartParsing()}
                  className="flex-1 bg-primary text-primary-foreground hover:bg-primary/90"
                >
                  {isProcessing ? (
                    <>
                      <Spinner className="mr-2 size-4 animate-spin" />
                      {parsingStates[currentStateIndex]}
                    </>
                  ) : (
                    "开始解析"
                  )}
                </Button>
              )}
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
